import {PlayerReduxState} from "../types";

export default function isPreview(state: PlayerReduxState) {
  return state.isPreview;
}
